import { useState } from "react";
import { Button, ButtonProps } from "semantic-ui-react";

import { ExcelRow, exportToExcel } from "./exportToExcel";

type ExportToExcelButtonProps = Omit<
  ButtonProps,
  "onClick" | "icon" | "content" | "type" | "loading"
> & {
  headers: string[];
  getRows: () => ExcelRow[] | Promise<ExcelRow[]>;
  fileName: string;
  sheetName?: string;
  onError?: (error: unknown) => void;
};

const ExportToExcelButton = ({
  headers,
  getRows,
  fileName,
  sheetName = "Sheet1",
  onError,
  disabled,
  ...buttonProps
}: ExportToExcelButtonProps) => {
  const [isExporting, setIsExporting] = useState(false);

  const handleClick = async () => {
    setIsExporting(true);

    try {
      exportToExcel(await getRows(), headers, fileName, sheetName);
    } catch (error) {
      onError?.(error);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Button
      type="button"
      size="tiny"
      basic
      icon="file excel outline"
      content="Export to Excel"
      {...buttonProps}
      loading={isExporting}
      disabled={disabled || isExporting}
      onClick={handleClick}
    />
  );
};

export default ExportToExcelButton;
